import {Helmet} from '@dr.pogodin/react-helmet';
import {showNotification} from 'platform/components';

import {AccPatchDocumentExportDateSetNullApiArg} from '@dms/api/core';
import {useAccPatchDocumentExportDateSetNullMutation} from '@dms/api/finance';
import i18n from '@dms/i18n';
import {testIds} from '@dms/routes';
import {SettingsTemplate} from '@dms/settings/shared';
import {DmsDataGrid, handleApiError} from '@dms/shared';

import type {ActionCallback} from 'features/eag-grid';

const PREDEFINED_COLUMNS = ['documentId', 'typDokladu'] as const;

export function AccountingActivityLog() {
  const [patchConfiguration] = useAccPatchDocumentExportDateSetNullMutation();

  const actionCallback: ActionCallback<typeof PREDEFINED_COLUMNS> = ({
    actionKey,
    getColumnData,
    refreshData,
  }) => {
    const documentId = getColumnData<string>('documentId')?.value;
    const typDokladu = getColumnData<{key: AccPatchDocumentExportDateSetNullApiArg['type']}>(
      'typDokladu'
    )?.value;

    if (!documentId || !typDokladu?.key) {
      showNotification.error();
      return;
    }

    if (actionKey === 'reexport') {
      patchConfiguration({
        id: documentId,
        type: typDokladu.key,
      })
        .unwrap()
        .then(() => {
          refreshData();
        })
        .catch(handleApiError);
    }
  };

  const title = i18n.t('page.accounting.labels.accountingActivityLog');

  return (
    <>
      <Helmet title={title} />
      <SettingsTemplate
        data-testid={testIds.settings.accountingActivityLog('header')}
        header={{
          title,
        }}
      >
        <DmsDataGrid
          gridCode="documents-pre-accounting"
          predefinedColumns={PREDEFINED_COLUMNS}
          actionCallback={actionCallback}
        />
      </SettingsTemplate>
    </>
  );
}
